// extracted by mini-css-extract-plugin
export default {"controlsLayout":"FilterControls_controlsLayout__ethx9","placeHolderShimmer":"FilterControls_placeHolderShimmer__fp8Hk"};